import { getTestAttributes, slug, noop } from '@chillibean/component-library';
import { clsx } from 'clsx';
import { PropTypes } from 'prop-types';
import { forwardRef } from 'react';
import { Key } from 'ts-key-enum';

import RadioField from '../../../../../../primitives/form/RadioField/RadioField';

const FormTemplateWorkflowCard = forwardRef((props, ref) => {
  const {
    workflowDefinition,
    selectedWorkflowDefinitionId = undefined,
    disabled,
    loading = false,
    tooltipText = undefined,
    onSelect = noop,
  } = props;

  const active = workflowDefinition.id === selectedWorkflowDefinitionId;

  const onKeyUp = (event) => {
    if (Key.Enter === event.key) {
      onSelect(workflowDefinition.id);
    }
  };

  return (
    <div
      ref={ref}
      className={clsx({
        'form-template-workflow-card': true,
        'form-template-workflow-card__active': active,
        'form-template-workflow-card__disabled': disabled,
        'form-template-workflow-card__loading': loading,
      })}
      onClick={() => !disabled && onSelect(workflowDefinition.id)}
      onKeyUp={onKeyUp}
      title={tooltipText}
      role="button"
      tabIndex={0}
      {...getTestAttributes(`${slug(workflowDefinition.name)}-card`)}
    >
      <div className="form-template-workflow-card-info">
        <div className="form-template-workflow-card-name">{workflowDefinition.name}</div>
        <div className="form-template-workflow-card-description">{workflowDefinition.description}</div>
      </div>
      <RadioField
        fieldID={`${slug(workflowDefinition.name)}-radio-field`}
        handleChange={() => {
          onSelect(workflowDefinition.id);
        }}
        selectedOption={`${selectedWorkflowDefinitionId}`}
        optionValue={`${workflowDefinition.id}`}
        disabled={disabled}
      />
    </div>
  );
});

FormTemplateWorkflowCard.propTypes = {
  workflowDefinition: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  selectedWorkflowDefinitionId: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  tooltipText: PropTypes.string,
  onSelect: PropTypes.func,
};

export default FormTemplateWorkflowCard;
